let _counter = 0;

export const genId = (prefix = 'id'): string =>
  `${prefix}_${Date.now()}_${++_counter}`;
